<template>
    <div class='pg-info'>
        <answer-header type="back"></answer-header>
        <img class="logo" src="../assets/logo.png">
        <div class="input-mod">
            <div class="input-item">
                <div class="label">ဖုန်းနံပါတ်: </div>
                <input type="text" v-model="mobile" name="" readonly>
            </div>
            <div class="input-item">
                <div class="label">အခြားအမည်: </div>
                <input type="text" v-model="name" name="">
            </div>
            <div class="input-item">
                <div class="label">အလုပ်အကိုင်: </div>
                <input type="text" v-model="job" name="">
            </div>
            <div class="input-item">
                <div class="label">အသက်: </div>
                <input type="text" v-model="age" name="">
            </div>
            <div class="input-item">
                <div class="label">ပညာအရည်အချင်း: </div>
                <input type="text" v-model="edu" name="">
            </div>
            <div class="input-item">
                <div class="label">လိပ်စာ: </div>
                <input type="text" v-model="addr" name="">
            </div>
            <div class="input-item">
                <div class="label">FB အကောင့်: </div>
                <input type="text" v-model="facebook" name="">
            </div>
        </div>
        <div class="btn btn-block" @click="_save">Save</div>
    </div>
</template>

<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Info',
    components: {answerHeader},
    data(){
        return {
            mobile: '',
            id: '',
            name: '',
            job: '',
            age: '',
            edu: '',
            addr: '',
            facebook: ''
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    created(){
        this._fetchUserInfo();
    },
    methods: {
        _fetchUserInfo(){
            Utils.$ajax({
                url: '/user/info',
            }).done(res=>{
                if(res.code!=0){
                    this.$toast(res.msg);
                    return;
                }
                this.mobile = res.data.mobile;
                Object.assign(this, res.data.info);
            })
        },
        _save(){
            var sendData = {
                mobile: this.mobile,
                name: this.name,
                job: this.job,
                age: this.age,
                edu: this.edu,
                addr: this.addr,
                facebook: this.facebook
            };

            Utils.$ajax({
                type: 'post',
                url: '/user/updata',
                data: sendData
            }).done(res=>{
                if(res.code != 0){
                    this.$toast(res.msg);
                    return;
                }
                this.$toast(res.msg)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .pg-info{
        color: #fff;
    }
    .input-item{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: rem(30) 0;

        input{
            width: rem(400);
            height: rem(70);
            flex-shrink: 0;
            margin-left: rem(20);
        }
        .label{
            font-size: rem(30);
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Info.vue